/**
 * SearchWordRegisterContainer
 * --
 */
import React from 'react';
import SearchWordRegisterPresenter from './SearchWordRegisterPresenter';

const SearchWordRegisterContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <SearchWordRegisterPresenter />
    </>
  );
};

export default SearchWordRegisterContainer;
